module.exports = __webpack_public_path__ + "img/03-title-01.673e4bfe.png";